// extracted by mini-css-extract-plugin
export default {"boxShadow":"CampaignManageCampaignsCard_boxShadow__KL7TM","container":"CampaignManageCampaignsCard_container__98NlY"};